import { Injectable } from '@angular/core';
import { CusHttp } from '../core/services/CusHttp';


// 岗位列表接口
const joblist = 'v1/position/search?';

//合作企业高校接口
const COOPERDATA_url = 'v1/public/cooperation';
@Injectable()
export class Activity1710Service {
  constructor( public _http: CusHttp ) { }


  // 岗位列表接口 实习就业首页岗位搜索接口
  getJobsList( city_id?: string, num?: any ) {
    let a = new URLSearchParams();
    a.append( 'jobType', '103' );
    city_id && a.append( 'city_id', city_id );
    num && a.append( 'num', num );
    return this._http.get( `${joblist}` + a.toString() );
  }
  //合作企业高校接口
  getCooperData( type: string ) {
    let url = COOPERDATA_url + `?type=${type}`;
    return this._http.get( url );
  }

}



// WEBPACK FOOTER //
// /data/wwwroot/xzhipin/app-client/src/app/activity1710/activity1710.service.ts